export default "__VITE_ASSET__Bu7Sp0JL__"